
import Vue from "vue";
import AppFileUpload from "@/components/FileUploadDropAndProgress.vue";
import { AuthService } from "@/services/auth-service";
import AppFilePreview  from "@/components/FileImagePreview.vue";

export default Vue.extend({
	data(){
		return {
			saving: false,
			value: null as File | null
		};
	},
	computed: {
		saveDisabled():boolean {
			if (this.saving) {
				return true;
			}
			if (this.value == null){
				return true;
			}
			return false;
		},
		cancelDisabled():boolean{
			return this.saving;
		},
		allowedExtensions():string[]{
			return ["jpg", "jpeg", "png"];
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async save(){
			if (!this.value){
				return;
			}
			if (this.saving) {
				return;
			}
			try{
				this.saving = true;
				let userInfo = await AuthService.setProfileImg(this.value);
				AuthService.wfUser.ProfileImg = userInfo.ProfileImg;
			}catch(err){
			}
			this.saving = false;
			this.close();
			return;
		}
	},
	components: {
		AppFileUpload,
		AppFilePreview
	},
	i18nEx: {
		componentPrefix: "components.account"
	}
});
